import styled from 'styled-components'

export const ModalCard = styled.div`
  width: 95%;
  max-width: 480px;
  box-sizing: border-box;
  padding: 32px;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  h2 {
    margin: 0;
    font-size: 1.8rem !important;
    font-weight: 600;
    color: #2c2c2c;
  }
`

export const Dropzone = styled.div<{
  dragActive: boolean
  hasError: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 180px;
  box-sizing: border-box;
  padding: 32px 20px;
  border-radius: 12px;
  border: 1.5px dashed
    ${({ dragActive, hasError }) =>
      hasError ? '#e02424' : dragActive ? '#ff5100' : '#e2e2e2'};
  background: ${({ dragActive }) => (dragActive ? '#fff1e0' : '#fafafa')};
  cursor: pointer;
  text-align: center;
  outline: none;

  svg {
    font-size: 2.8rem;
    color: #ff5100;
  }

  .dropzone-cta {
    font-size: 1.4rem !important;
    font-weight: 600;
    color: #2c2c2c;
  }

  .dropzone-hint {
    font-size: 1.2rem !important;
    color: #8c8c8c;
  }

  .dropzone-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    max-width: 100%;

    svg {
      font-size: 3.2rem;
    }
  }

  .dropzone-file-name {
    font-size: 1.4rem !important;
    font-weight: 600;
    color: #2c2c2c;
    word-break: break-word;
    max-width: 100%;
  }
`

export const FileError = styled.span`
  font-size: 1.2rem !important;
  font-weight: 500;
  color: #e02424;
`

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`

export const CancelButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  background: #e2e2e2;
  color: #2c2c2c;
  font-size: 1.4rem !important;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #d5d5d5;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const ConfirmButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  background: #ff5100;
  color: #f7f7f7;
  font-size: 1.4rem !important;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #e64800;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
